import { api } from "./configs/axiosConfigs"

export const SearchProductsAPI = {
    
    getSearchProducts: async (data:any) => {
        const response = await api.get(
            '/pricelistproducts/search', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getFilterProducts: async (data:any) => {
        const response = await api.get(
            '/pricelistproducts/products', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}